<template>
  <div class="container">
    <div class="people" v-if="query">
      <div class="people-label">
        <i
          class="iconfont1 icon-user-wait"
          style="color: #3478f7; font-size: 17px; padding-right: 3px"
        ></i
        >就诊人：
      </div>
      <div class="people-text">{{ query.patientName }}</div>
    </div>
    <div class="detail" v-if="query">
      <div class="detail-label">处方号：</div>
      <div class="detail-text">{{ query.itemCode }}</div>
    </div>
    <div class="pay-num" v-if="query">
      <div class="pay-num-label">付款金额</div>
      <div class="pay-num-text">￥{{ query.amount }}</div>
    </div>
    <div class="btn-box" v-if="query">
      <van-button round type="info" size="large" @click="goPay"
        >立即付款</van-button
      >
    </div>
    <!-- <van-empty v-if="!query" image="error" description="参数错误" /> -->
  </div>
</template>

<script>
import { createRecipe, getDefaultPatient } from '@/api/api'
import { _date_ } from '../../utils/calculationDate'
import { Toast } from 'vant'
export default {
  name: 'payDetail',
  data() {
    return {
      query: null,
      patientsData: ''
    }
  },
  created() {},
  mounted() {
    console.log(this.$route.query)

    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
    this.query = this.$route.query ? this.$route.query : null
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    goBack() {
      window.history.go(-2)
    },
    dateProp(datecode) {
      return _date_(datecode)
    },
    goPay() {
      let data = {
        /** 交易金额 单位分 */
        amount: this.query.amount,
        /** 就诊人ID */
        patientId: this.query.patientId,
        /** 就诊人姓名 */
        patientName: this.query.patientName,
        orderType: '1',
        clinicCode: this.query.clinicCode,
        itemCode: this.query.itemCode,
        itemCodeJson: JSON.stringify(this.query.paramsdata)
      }
      createRecipe(data).then(res => {
        if (res.code == 200 && res.msg == 'OK') {
          this.$router.replace({
            name: 'goPay',
            params: { ...res.data, preType: 'pre' }
          })
        } else {
          Toast.fail(res.data || '未知错误')
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background: rgb(242, 248, 253);
}
.people {
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);
  &-label {
    width: 100px;
    color: #666;
    display: flex;
    align-items: center;
    font-size: 18px;
  }
  &-text {
    width: calc(100% - 80px);
    font-size: 18px;
  }
}
.detail {
  width: 100%;
  display: flex;
  align-items: center;
  height: 38px;
  background: #fff;
  padding: 0 15px;
  &-label {
    width: 100px;
    color: #666;
    display: flex;
    align-items: center;
    font-size: 18px;
  }
  &-text {
    width: calc(100% - 70px);
    font-size: 18px;
  }
}
.pay-num {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);
  border-top: 1px solid rgb(234, 234, 234);
  &-label {
    display: flex;
    align-items: center;
    font-size: 18px;
  }
  &-text {
    font-size: 18px;
    color: rgb(237, 125, 84);
  }
}
.btn-box {
  width: 100%;
  padding: 0 15px;
  padding-top: 15px;
}
.btn-box button {
  height: 48px;
  font-size: 18px;
}
@font-face {
  font-family: 'iconfont1';
  src: url('data:font/truetype;charset=utf-8;base64,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')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont1 {
  font-family: 'iconfont1' !important;
  font-size: 18px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-user-wait:before {
  content: '\e6b2';
}
</style>
